<template>
    <div>
        <v-card v-if="showCard" class="mb-4 pa-4" outlined>
            <div class="d-flex flex-column mb-3">
                <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-store</v-icon>
                    <span class="font-weight-bold subtitle-1">{{ group.shopName }}</span>
                </div>
                <div v-if="group.seller" class="ml-8">
                    <div class="caption grey--text text--darken-1" v-if="group.seller.phone">เบอร์โทรศัพท์: {{ group.seller.phone }}</div>
                    <div class="caption grey--text text--darken-1" v-if="getFullAddress(group.seller)">ที่อยู่: {{ getFullAddress(group.seller) }}</div>
                </div>
            </div>
            <v-divider class="mb-4"></v-divider>

            <!-- Table Header -->
            <v-row align="center" class="text-center font-weight-bold grey--text text--darken-1 mb-2">
                <v-col cols="5" class="text-left">สินค้า</v-col>
                <v-col cols="3">ราคา</v-col>
                <v-col cols="2">จำนวน</v-col>
                <v-col cols="2">รวม</v-col>
            </v-row>

            <!-- Items -->
            <OrderItem v-for="(item, index) in group.items" :key="item.id" :item="item"
                :last-item="index === group.items.length - 1" />
        </v-card>

        <div v-else>
            <div class="d-flex flex-column mb-3">
                <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-store</v-icon>
                    <span class="font-weight-bold subtitle-1">{{ group.shopName }}</span>
                </div>
                <div v-if="group.seller" class="ml-8">
                    <div class="caption grey--text text--darken-1" v-if="group.seller.phone">เบอร์โทรศัพท์: {{ group.seller.phone }}</div>
                    <div class="caption grey--text text--darken-1" v-if="getFullAddress(group.seller)">ที่อยู่: {{ getFullAddress(group.seller) }}</div>
                </div>
            </div>

            <!-- Table Header (conditionally shown) -->
            <v-row v-if="showHeader" align="center" class="text-center font-weight-bold grey--text text--darken-1 mb-2">
                <v-col cols="5" class="text-left">สินค้า</v-col>
                <v-col cols="3">ราคา</v-col>
                <v-col cols="2">จำนวน</v-col>
                <v-col cols="2">รวม</v-col>
            </v-row>

            <!-- Items -->
            <OrderItem v-for="(item, index) in group.items" :key="item.id" :item="item"
                :last-item="index === group.items.length - 1" />
        </div>
    </div>
</template>

<script>
import OrderItem from "./OrderItem.vue";
import { getFullAddress } from "@/utils/address";

export default {
    name: "OrderShopGroup",
    components: {
        OrderItem,
    },
    props: {
        group: {
            type: Object,
            required: true,
        },
        showCard: {
            type: Boolean,
            default: true,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        getFullAddress
    }
};
</script>

<style scoped></style>
